import { createFileRoute } from '@tanstack/react-router'

import Accounting from '@/features/accounting/pages/accounting'

export const Route = createFileRoute('/_shell/accounting/')({
  component: Accounting,
})
